
const BUTTON_TYPES = Object.freeze({
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
});

export default BUTTON_TYPES;
